// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"y1-z","colorTextValue":"z1-z","swatches":"A1-z","collapseLink":"B1-z","isCollapsed":"C1-z","dropdown":"D1-z","disabled":"E1-z"};